module.exports = __webpack_public_path__ + "static/logo-817b3b343628e3ef0204503d37197797.svg";